import { i18n } from "@lingui/core"
import { defineMessage } from "@lingui/macro"
import { CSSProperties } from "react"
import SortAscIcon from "remixicon-react/SortAscIcon"
import SortDescIcon from "remixicon-react/SortDescIcon"

import * as Select from "@/ui/select"

import { Sorting } from "../model"

type Option = {
  value: Sorting
  direction: "asc" | "desc"
}

const options: Array<Option> = [
  {
    value: "default",
    direction: "desc",
  },
  {
    value: "priceAsc",
    direction: "asc",
  },
  {
    value: "priceDesc",
    direction: "desc",
  },
]

const defaultLabels = {
  default: defineMessage({
    id: "auctions.sortBy.endsAtDescending",
    message: "Čas do konce",
  }),
  priceAsc: defineMessage({
    id: "auctions.sortBy.priceAscending",
    message: "Od nejnižší ceny",
  }),
  priceDesc: defineMessage({
    id: "auctions.sortBy.priceDescending",
    message: "Od nejvyšší ceny",
  }),
}

export type SortingLabels = Partial<typeof defaultLabels>

export function SortingSelect(props: {
  value: Sorting
  onValueChange: (value: Sorting) => void
  labels?: SortingLabels
  style?: CSSProperties
}) {
  const { value, onValueChange, labels, ...triggerProps } = props
  const selectedOption = options.find((option) => option.value === value)
  const Icon = selectedOption?.direction === "asc" ? SortAscIcon : SortDescIcon

  return (
    <Select.Root value={value} onValueChange={onValueChange}>
      <Select.Trigger addonBefore={<Icon size="1.25em" />} {...triggerProps} />
      <Select.Content>
        {options.map((option) => (
          <Select.Item key={option.value} value={option.value}>
            {i18n._(labels?.[option.value] ?? defaultLabels[option.value])}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  )
}
